<template lang="html">
  <div class="card-person">
    <div class="image">
      <img :src="imageURL" alt="Person Image" />
    </div>
    <div class="content">
      <h6 class="title">{{ autor }}</h6>
      <span class="rol">{{ rol }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imageURL: String,
    autor: String,
    rol: String,
  },
};
</script>
<style lang="css" scoped>
.card-person {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card-person .content {
  margin-top: -40px;
  background: #33647e;
  padding: 20px 40px;
  text-align: center;
  transition: all 0.5s ease-in-out;
  width: 80%;
  min-height: 85px;
}

.card-person .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: #ffffff;
  margin-bottom: 0;
  transition: all 0.5s ease-in-out;
}

.card-person .content .rol {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 0;
  color: #ffffff;
  transition: all 0.5s ease-in-out;
}

.image img {
  width: 269px;
  height: 337px;
}

@media (max-width: 768px) {
  .card-person .content {
    padding: 10px 20px;
  }
  .card-person .content .title {
    font-size: 14px;
    line-height: 17px;
  }
  .card-person .content .rol {
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
